const PREFIX = 'wc-click-collect:';

function key(slug, part) {
  return `${PREFIX}${String(slug || '').trim().toLowerCase()}:${part}`;
}

function readJson(storageKey) {
  try {
    const raw = localStorage.getItem(storageKey);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

function writeJson(storageKey, value) {
  try {
    localStorage.setItem(storageKey, JSON.stringify(value));
  } catch {
    /* quota / private mode */
  }
}

export function loadClickCollectCustomer(slug) {
  const o = readJson(key(slug, 'customer'));
  if (!o || typeof o !== 'object') return null;
  return {
    name: String(o.name || ''),
    email: String(o.email || ''),
    phone: String(o.phone || ''),
    note: String(o.note || ''),
  };
}

export function saveClickCollectCustomer(slug, customer) {
  if (!slug) return;
  writeJson(key(slug, 'customer'), {
    name: String(customer?.name || ''),
    email: String(customer?.email || ''),
    phone: String(customer?.phone || ''),
    note: String(customer?.note || ''),
  });
}

export function loadClickCollectCart(slug) {
  const o = readJson(key(slug, 'cart'));
  if (!o || typeof o !== 'object') return null;
  const cart = {};
  for (const [id, qty] of Object.entries(o)) {
    const n = Math.floor(Number(qty) || 0);
    if (id && n > 0) cart[id] = n;
  }
  return cart;
}

export function saveClickCollectCart(slug, cart) {
  if (!slug) return;
  writeJson(key(slug, 'cart'), cart && typeof cart === 'object' ? cart : {});
}

export function clearClickCollectCart(slug) {
  try {
    localStorage.removeItem(key(slug, 'cart'));
  } catch {
    /* ignore */
  }
}

export function loadClickCollectPickup(slug) {
  const o = readJson(key(slug, 'pickup'));
  if (!o || typeof o !== 'object') return null;
  const dateStr = String(o.date || '').trim();
  const slot = String(o.slot || '').trim();
  if (!dateStr || !slot) return null;
  const d = new Date(`${dateStr}T12:00:00`);
  if (Number.isNaN(d.getTime())) return null;
  return { date: d, slot };
}

export function saveClickCollectPickup(slug, pickupDate, pickupSlot) {
  if (!slug || !pickupDate || !pickupSlot) return;
  const d = pickupDate instanceof Date ? pickupDate : new Date(pickupDate);
  if (Number.isNaN(d.getTime())) return;
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  writeJson(key(slug, 'pickup'), { date: `${y}-${m}-${day}`, slot: pickupSlot });
}

/** Filtre les lignes dont les produits ne sont plus au menu. */
export function sanitizeCartForAvailableItems(cart, itemIds) {
  const ids = new Set(itemIds || []);
  const out = {};
  for (const [id, qty] of Object.entries(cart || {})) {
    if (!ids.has(id)) continue;
    const n = Math.floor(Number(qty) || 0);
    if (n > 0) out[id] = n;
  }
  return out;
}
